































































































































































































































import "./event-detail.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment-timezone";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../common/user-avatar.vue";
import ResizableTextarea from "../common/ResizableTextarea.js";
import TextareaAutosize from "../common/TextareaAutosize.vue";
import AttachmentEditor from "../goals/attachment-editor.vue";
import RecurrenceSetup from "./recurrence-setup.vue";
import DeleteEvent from "./delete-event.vue";
import { Container, Draggable } from "vue-smooth-dnd";
let _ = require("lodash");
let timezones = require("../common/timezones.json");

export default Vue.extend({
  name: "EventDetail",
  components: { UserAvatar, AttachmentEditor, RecurrenceSetup, Container, Draggable, ResizableTextarea, TextareaAutosize, DeleteEvent },
  props: {
    event: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      eventModel: {
        title: "",
        description: "",

        recurrence: null,
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
        timeOffset: 0,

        allDay: false,
        timezone: null,
        useTimezone: false,

        selectedMemberIds: [],
        members: [],

        attachments: [],
      },

      showRecurrenceSetup: false,
      edittingRecurrence: null,

      showAssignments: false,

      showAttachmentEditor: false,
      disableAttachmentEdit: false,

      showDeleteEvent: false,

      timeOptions: [
        { value: "00:00", label: "12:00 AM", disabled: false },
        { value: "00:30", label: "12:30 AM", disabled: false },
        { value: "01:00", label: "1:00 AM", disabled: false },
        { value: "01:30", label: "1:30 AM", disabled: false },
        { value: "02:00", label: "2:00 AM", disabled: false },
        { value: "02:30", label: "2:30 AM", disabled: false },
        { value: "03:00", label: "3:00 AM", disabled: false },
        { value: "03:30", label: "3:30 AM", disabled: false },
        { value: "04:00", label: "4:00 AM", disabled: false },
        { value: "04:30", label: "4:30 AM", disabled: false },
        { value: "05:00", label: "5:00 AM", disabled: false },
        { value: "05:30", label: "5:30 AM", disabled: false },
        { value: "06:00", label: "6:00 AM", disabled: false },
        { value: "06:30", label: "6:30 AM", disabled: false },
        { value: "07:00", label: "7:00 AM", disabled: false },
        { value: "07:30", label: "7:30 AM", disabled: false },
        { value: "08:00", label: "8:00 AM", disabled: false },
        { value: "08:30", label: "8:30 AM", disabled: false },
        { value: "09:00", label: "9:00 AM", disabled: false },
        { value: "09:30", label: "9:30 AM", disabled: false },
        { value: "10:00", label: "10:00 AM", disabled: false },
        { value: "10:30", label: "10:30 AM", disabled: false },
        { value: "11:00", label: "11:00 AM", disabled: false },
        { value: "11:30", label: "11:30 AM", disabled: false },
        { value: "12:00", label: "12:00 PM", disabled: false },
        { value: "12:30", label: "12:30 PM", disabled: false },
        { value: "13:00", label: "1:00 PM", disabled: false },
        { value: "13:30", label: "1:30 PM", disabled: false },
        { value: "14:00", label: "2:00 PM", disabled: false },
        { value: "14:30", label: "2:30 PM", disabled: false },
        { value: "15:00", label: "3:00 PM", disabled: false },
        { value: "15:30", label: "3:30 PM", disabled: false },
        { value: "16:00", label: "4:00 PM", disabled: false },
        { value: "16:30", label: "4:30 PM", disabled: false },
        { value: "17:00", label: "5:00 PM", disabled: false },
        { value: "17:30", label: "5:30 PM", disabled: false },
        { value: "18:00", label: "6:00 PM", disabled: false },
        { value: "18:30", label: "6:30 PM", disabled: false },
        { value: "19:00", label: "7:00 PM", disabled: false },
        { value: "19:30", label: "7:30 PM", disabled: false },
        { value: "20:00", label: "8:00 PM", disabled: false },
        { value: "20:30", label: "8:30 PM", disabled: false },
        { value: "21:00", label: "9:00 PM", disabled: false },
        { value: "21:30", label: "9:30 PM", disabled: false },
        { value: "22:00", label: "10:00 PM", disabled: false },
        { value: "22:30", label: "10:30 PM", disabled: false },
        { value: "23:00", label: "11:00 PM", disabled: false },
        { value: "23:30", label: "11:30 PM", disabled: false },
      ],
    };
  },
  watch: {
    showModal(newVal) {
      let context = this as any;

      if (newVal === true) {
        context.eventModel.title = context.event.title;
        context.eventModel.description = context.event.description;

        context.eventModel.recurrence = context.event.recurrence ? Object.assign({}, context.event.recurrence) : { enabled: false };

        let startDate = moment(context.event.startDate);
        let endDate = moment(context.event.endDate);
        if (context.event.useTimezone) {
          startDate.tz(context.event.timezoneAbbr);
          endDate.tz(context.event.timezoneAbbr);
        }
        context.eventModel.startTime = startDate.format("HH:mm");
        context.eventModel.startDate = moment(startDate.format("YYYY-MM-DD"), "YYYY-MM-DD").toDate();
        context.eventModel.endTime = endDate.format("HH:mm");
        context.handleEndTimeChange(context.eventModel.endTime);
        context.eventModel.endDate = moment(endDate.format("YYYY-MM-DD"), "YYYY-MM-DD").toDate();
        context.eventModel.allDay = context.event.allDay;
        context.eventModel.useTimezone = context.event.useTimezone;
        context.eventModel.timezone = context.event.timezone;

        let members = context.currentTeam ? context.currentTeam.members : [];
        context.eventModel.selectedMemberIds = context.event && context.event.selectedMemberIds ? context.event.selectedMemberIds : [];
        context.eventModel.members = members.map((member) => {
          let result = Object.assign({}, member);

          result.selected = !!_.find(context.eventModel.selectedMemberIds, function (id) {
            return id === member.memberId;
          });

          return result;
        });

        context.eventModel.attachments = context.event.attachments ? context.event.attachments.map((attachment) => Object.assign({}, attachment)) : [];
      }
    },
  },
  computed: {
    ...mapState("team", ["currentTeam"]),
    ...mapGetters("team", ["canEditCurrentTeam"]),
    showModal(): boolean {
      return this.showEditor;
    },
    timezones() {
      return timezones;
    },
    prettyRecurrence() {
      let recurrence = (this as any).eventModel.recurrence;
      if (recurrence && recurrence.enabled === true) {
        let every = "";
        if (recurrence.timeframe === "daily") {
          every = recurrence.daily === "weekday" ? "every weekday" : "every day";
        } else if (recurrence.timeframe === "weekly") {
          every = recurrence.weekly.length > 0 ? "every " + recurrence.weekly.join(",") : "every day";
        } else if (recurrence.timeframe === "monthly") {
          if (recurrence.monthly === "dayIncrements") {
            every = `every ${recurrence.dayIncrement} days after day ${recurrence.dayIncrementStart}`;
          } else if (recurrence.monthly === "daySpecific") {
            every = recurrence.daySpecific.length > 0 ? "day " + recurrence.daySpecific.join(",") : "every day";
          }
        }

        let endTime = moment(recurrence.startTime, "HH:mm").add(recurrence.duration, "minutes").format("HH:mm");
        let startDate = moment(recurrence.startDate).format("L");
        let endDate = moment(recurrence.endDate).format("L");
        return `Occurs ${every} effective ${startDate} until ${endDate} from ${recurrence.startTime} to ${endTime}`;
      } else {
        return "";
      }
    },
    rules() {
      let rules = {
        title: [
          {
            required: true,
            message: "Please input title",
            trigger: "change",
          },
        ],
        timezone: [
          {
            required: true,
            message: "Please select time zone",
            trigger: "change",
          },
        ],
      };

      if (!this.eventModel.recurrence || this.eventModel.recurrence.enabled !== true) {
        rules["startDate"] = [
          {
            required: true,
            message: "Please pick a date",
          },
        ];

        rules["endDate"] = [
          {
            required: true,
            message: "Please pick a date",
          },
        ];

        if (this.eventModel.allDay !== true) {
          rules["startTime"] = [
            {
              required: true,
              message: "Please select start time",
            },
          ];

          rules["endTime"] = [
            {
              required: true,
              message: "Please select end time",
            },
          ];
        }
      }

      return rules;
    },
  },
  methods: {
    titleChanged(value) {
      (this.$refs.TitleFormItem as any).$emit.apply(this.$refs.TitleFormItem, ["on-form-change", value]);
    },
    handleSave($event) {
      let context = this as any;

      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = context.$refs.EventForm as any;

      form.validate((valid: boolean) => {
        if (valid) {
          let eventData = {
            id: context.event.id,
            serieId: context.event.serieId,
            title: context.eventModel.title,
            description: context.eventModel.description,
            recurrence: context.eventModel.recurrence,
            selectedMemberIds: context.eventModel.selectedMemberIds,
            attachments: context.eventModel.attachments,
            allDay: context.eventModel.allDay,
            useTimezone: context.eventModel.useTimezone,
            timezone: context.eventModel.timezone,
            timezoneAbbr: context.event.timezoneAbbr,
            startDate: moment(`${moment(context.eventModel.startDate).format("YYYY-MM-DD")} ${context.eventModel.allDay ? "00:00" : context.eventModel.startTime}`, "YYYY-MM-DD HH:mm").toString(),
            endDate: moment(`${moment(context.eventModel.endDate).format("YYYY-MM-DD")} ${context.eventModel.allDay ? "00:00" : context.eventModel.endTime}`, "YYYY-MM-DD HH:mm").toString(),
          };

          if (context.eventModel.useTimezone) {
            let zones = context.timezones.filter((zone) => zone.value === context.eventModel.timezone);

            let a = moment(`${moment(context.eventModel.startDate).format("YYYY-MM-DD")} ${context.eventModel.allDay ? "00:00" : context.eventModel.startTime}`, "YYYY-MM-DD HH:mm").toDate();
            eventData.startDate = moment
              .tz(`${moment(context.eventModel.startDate).format("YYYY-MM-DD")} ${context.eventModel.allDay ? "00:00" : context.eventModel.startTime}`, "YYYY-MM-DD HH:mm", zones[0].utc[0])
              .toString();

            eventData.endDate = moment
              .tz(`${moment(context.eventModel.endDate).format("YYYY-MM-DD")} ${context.eventModel.allDay ? "00:00" : context.eventModel.endTime}`, "YYYY-MM-DD HH:mm", zones[0].utc[0])
              .toString();

            eventData.timezoneAbbr = zones[0].utc[0];
          }

          context.$emit("save", eventData, $event);

          target.disabled = false;
        } else {
          target.disabled = false;
        }
      });
    },
    handleDeleteEvent($event, option) {
      this.showDeleteEvent = false;
      this.emitDelete($event, option);
    },
    handleDelete($event) {
      let context = this as any;
      if (context.event.recurrence && context.event.recurrence.enabled === true) {
        context.showDeleteEvent = true;
      } else {
        context.emitDelete($event);
      }
    },
    emitDelete($event, option) {
      let context = this as any;
      this.$emit(
        "delete",
        $event,
        {
          id: context.event.id,
          serieId: context.event.serieId,
          title: context.eventModel.title,
          description: context.eventModel.description,
          recurrence: context.eventModel.recurrence,
          selectedMemberIds: context.eventModel.selectedMemberIds,
          attachments: context.eventModel.attachments,
          allDay: context.eventModel.allDay,
          useTimezone: context.eventModel.useTimezone,
          timezone: context.eventModel.timezone,
          startDate: moment(`${moment(context.eventModel.startDate).format("YYYY-MM-DD")} ${context.eventModel.startTime}`, "YYYY-MM-DD HH:mm").toDate(),
          endDate: moment(`${moment(context.eventModel.endDate).format("YYYY-MM-DD")} ${context.eventModel.endTime}`, "YYYY-MM-DD HH:mm").toDate(),
        },
        option
      );
    },
    makeRecurring() {
      let recurrence = Object.assign({}, this.eventModel.recurrence);
      recurrence.startTime = recurrence.startTime || this.getStartTime();
      recurrence.duration = recurrence.duration || 30;
      recurrence.startDate = recurrence.startDate || new Date();
      recurrence.endDate = recurrence.endDate || moment(recurrence.startDate).add(1, "M");
      this.edittingRecurrence = recurrence;
      this.showRecurrenceSetup = true;
    },
    handleStartTimeChange(selectedValue) {
      let startIndex = this.timeOptions.findIndex((option) => option.value === this.eventModel.startTime);
      if (startIndex >= 0 && this.eventModel.timeOffset > 0) {
        let endIndex = startIndex + this.eventModel.timeOffset;
        if (endIndex >= this.timeOptions.length) {
          endIndex = endIndex - this.timeOptions.length;
        }

        this.eventModel.endTime = this.timeOptions[endIndex].value;
      }
    },
    handleEndTimeChange(selectedValue) {
      let startIndex = this.timeOptions.findIndex((option) => option.value === this.eventModel.startTime);
      let endIndex = this.timeOptions.findIndex((option) => option.value === this.eventModel.endTime);
      if (startIndex >= 0 && endIndex >= 0) {
        let offset = endIndex - startIndex;
        this.eventModel.timeOffset = offset < 0 ? offset + this.timeOptions.length : offset;
      } else {
        this.eventModel.timeOffset = 0;
      }
    },
    getStartTime() {
      var now = new Date();
      now.setSeconds(0);
      now.setMinutes(Math.floor(now.getMinutes() / 30) * 30);
      return moment(now).format("HH:mm");
    },
    handleRecurrenceSetupSave(recurrence) {
      this.eventModel.recurrence = Object.assign(this.eventModel.recurrence, recurrence);
      this.showRecurrenceSetup = false;
    },
    handleMemberAssign(member) {
      member.selected = !member.selected;

      let context = this as any;
      context.selectedMemberIds = context.eventModel.members
        .filter((member) => member.selected === true)
        .map((member) => {
          return member.memberId;
        });
    },

    handleAddAttachment() {
      this.eventModel.attachments.push({
        link: null,
        title: "",
        type: null,
        status: "new",
      });
    },
    handleAttachmentEditting() {
      this.disableAttachmentEdit = true;
    },
    handleAttachmentEdittingEnd() {
      this.disableAttachmentEdit = false;
    },
    handleAttachmentCancelNew() {
      if (this.eventModel.attachments.length > 0 && this.eventModel.attachments[this.eventModel.attachments.length - 1]) {
        this.eventModel.attachments.pop();
      }
    },
    handleAttachmentRemove(attachment) {
      this.eventModel.attachments = this.eventModel.attachments.filter((a) => {
        return a.link !== attachment.link;
      });
    },

    uuid() {
      // Public Domain/MIT
      var d = new Date().getTime(); //Timestamp
      var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
    },
  },
});
